import { TeamsService } from 'app/API';
import type { TCall } from 'app/queries/types/TCall';

type TParams = {
  teamId: string;
  added: readonly string[];
  removed: readonly string[];
  onError: (message: string) => void;
};

export const commitTeamMembers = async ({ teamId, added, removed, onError }: TParams, call: TCall) => {
  if (added.length > 0) {
    await call(
      () => TeamsService.updateMembers({ organizationRoleId: teamId, requestBody: { memberIds: [...added] } }),
      { onError },
    );
  }

  for (const memberId of removed) {
    await call(() => TeamsService.removeMember({ organizationRoleId: teamId, memberId }), { onError });
  }
};
